import { render, staticRenderFns } from "./FireResistanceInner.vue?vue&type=template&id=b3a3b870&"
import script from "./FireResistanceInner.vue?vue&type=script&lang=js&"
export * from "./FireResistanceInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports